import WithRender from "../../templates/base/hiddenInputFields.html";
import { mapGetters, mapActions } from "vuex";

export default WithRender({
  computed: {
    ...mapGetters([
      "getChangeOptionsHiddenInputs",
      "getIsPersonalizationNewPage",
      "getWebProductTemplate"
    ]),
    getHiddenInputsWithIds: function () {
      let result = {};
      if (!this.getIsPersonalizationNewPage) {
        result = {
          templateId: {
            id: "templateId",
            name: "templateId",
            value: this.getWebProductTemplate
          }
        };
      }
      return result;
    }
  }
});
